<template>
  <div id="stockdetail">
    <el-row>
      <el-col :span="12">
        <ul>
          <li>供应商客户名称：{{ titleData.GYS_NAME }}</li>
          <li>订单编号：{{ titleData.RETURN_ORDER_CODE }}</li>
        </ul>
      </el-col>
      <el-col :span="12">
        <ul>
          <li>退货日期：{{ titleData.RETURN_DAY }}</li>
          <li>退货总金额：{{ Number(titleData.TOTAL_FEE).toFixed(2) }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange" :span-method="objectSpanMethod">
          <el-table-column prop="INDEX" label="序号" width="50"></el-table-column>
          <el-table-column prop="RETURN_PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="RETURN_PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="RETURN_TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价"></el-table-column>
          <el-table-column prop="RETURN_RETURN_COUNT" label="退货数量"></el-table-column>
          <el-table-column prop="PRODUCT_FEE" label="退货金额"></el-table-column>
          <el-table-column prop="RETURN_REASON" label="备注"></el-table-column>
          <el-table-column prop="DELIVER_INFO" label="出库信息">
            <el-table-column prop="PRODUCT_CODE" label="出库商品编码"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="出库商品名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="BATCH" label="出库批次"></el-table-column>
            <el-table-column prop="DELIVER_PRICE" label="出库单价"></el-table-column>
            <el-table-column prop="DELIVER_COUNT" label="出库数量"></el-table-column>
            <el-table-column prop="RETURN_COUNT" label="已退库数量"></el-table-column>
            <el-table-column type="selection" width="50" fixed="right" :selectable="selectable"></el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-button @click="toPrintTable">打印退货单</el-button>
        <el-button @click="returnToStock">退库</el-button>
      </el-col>
    </el-row>
    <!-- 退库模态框 -->
    <el-dialog title="退库信息" center :visible.sync="returnVisible" width="1200px">
      <el-table :data="returnList" border row-key="SALES_RETURN_DETAIL_ID">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编号" min-width="100"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" width="80"></el-table-column>
        <el-table-column prop="RETURN_RETURN_COUNT" label="总退货数量" width="100"></el-table-column>
        <el-table-column prop="RETURN_COUNT" label="已退库数量" width="100"></el-table-column>
        <el-table-column label="退库数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COUNT" :placeholder="`最多可退${getMax(scope.row) + scope.row.TYPE_UNIT}`" @change="getCount(scope.row)">
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="returnClose">取 消</el-button>
        <el-button size="small" @click="submitReturn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { salesReturnDetailFun, salesReturnWarehouseFun } from 'api/returnWare';
import { print } from 'api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      titleData: {},
      companyName: '',
      name: '',
      WHERE: Number(sessionStorage.getItem('where')),
      checkedArray: [],
      returnList: [],
      returnVisible: false,
      spanArr: [],
      printData: [],
    };
  },
  computed: {
    returnButtonVisible() { return JSON.parse(sessionStorage.getItem('returnMess')).HAVE_RETURN != 1; },
  },
  created() {
    this.companyName = sessionStorage.getItem('company');
    this.name = sessionStorage.getItem('name');
    this.getRecordDetail();
  },
  methods: {
    // ----------------------拉取数据
    getRecordDetail() {
      const params = {
        OTYPE: 94,
        SALES_RETURN_ID: Number(this.$route.params.srid),
      };
      salesReturnDetailFun(params).then((result) => {
        const arrTemp = [];
        result.DATA.forEach((item1, INDEX) => {
          item1.DELIVER_INFO.forEach((item2) => {
            arrTemp.push({
              SALES_RETURN_DETAIL_ID: item1.SALES_RETURN_DETAIL_ID,
              RETURN_PRODUCT_NAME: item1.PRODUCT_NAME,
              RETURN_PRODUCT_CODE: item1.PRODUCT_CODE,
              RETURN_TYPE_UNIT: item1.TYPE_UNIT,
              REAL_PRICE: item1.REAL_PRICE,
              RETURN_RETURN_COUNT: item1.RETURN_COUNT,
              PRODUCT_FEE: item1.PRODUCT_FEE,
              RETURN_REASON: item1.RETURN_REASON,
              ...item2,
              INDEX: INDEX + 1,
            });
          });
        });
        this.tableData = [...arrTemp];
        this.rowspan(this.tableData);
        this.titleData = result.TITLE;
        this.printData = result.DATA;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 多选框
    selectable(row, index) {
      const max = this.tableData.filter((item) => item.SALES_RETURN_DETAIL_ID == row.SALES_RETURN_DETAIL_ID).reduce((total, item) => total += Number(item.RETURN_COUNT), 0);
      if (max >= row.RETURN_RETURN_COUNT || row.RETURN_COUNT >= row.DELIVER_COUNT) {
        return false;
      }
      return true;
    },
    // 退库
    returnToStock() {
      if (this.checkedArray.length !== 0) {
        this.returnList = this.checkedArray;
        this.returnVisible = true;
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    returnClose() {
      this.returnVisible = false;
    },
    async submitReturn() {
      for (let i = 0; i < this.returnList.length; i++) {
        if (!this.getCount(this.returnList[i])) {
          return false;
        }
      }
      if (document.body.style.cursor === 'wait') {
        return;
      }
      document.body.style.cursor = 'wait';
      try {
        const submitArr = [];
        this.printData.forEach((item1) => {
          submitArr.push({
            SALES_RETURN_DETAIL_ID: item1.SALES_RETURN_DETAIL_ID,
            RETURN_INFO: this.returnList.filter((item2) => item1.SALES_RETURN_DETAIL_ID == item2.SALES_RETURN_DETAIL_ID).map((item3) => ({
              DELIVER_DETAIL_ID: item3.DELIVER_DETAIL_ID,
              PRODUCT_CODE: item3.PRODUCT_CODE,
              RETURN_COUNT: item3.COUNT,
            })),
          });
        });
        const params = {
          SALES_RETURN_ID: Number(this.$route.params.srid),
          LIST: submitArr,
        };
        await this.$prompt('请输入退库理由：', '提示', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', inputValue: '',
        // eslint-disable-next-line no-console
        }).then(({ value }) => params.COMMENT = value).catch((err) => { console.log(err); });
        salesReturnWarehouseFun(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.spanArr = [];
          this.getRecordDetail();
          this.returnVisible = false;
          document.body.style.cursor = 'default';
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          document.body.style.cursor = 'default';
        });
      } finally {
        document.body.style.cursor = 'default';
      }
      this.returnVisible = false;
    },
    handleSelectionChange(val) {
      this.checkedArray = val;
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main">';
      html += `<div class="title">${this.companyName}销售退货单</div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">供应商：${this.titleData.GYS_NAME}</div><div style="font-size: 20px;">日期：${this.titleData.RETURN_DAY}</div></div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">退货单编号：${this.titleData.RETURN_ORDER_CODE}</div><div style="font-size: 20px;">总金额：${Number(this.titleData.TOTAL_FEE).toFixed(2)}</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr style="font-size: 16px;"><th style="width: 50px">序号</th> <th>产品</th> <th>单位</th> <th  style="width: 40px">单价</th> <th style="width: 70px">退货数量</th> <th  style="width: 70px">退货金额</th> <th>备注</th> </tr>';
      html += '</div><div class="el-table__body">';
      this.printData.forEach((item, index) => {
        html += '<tr style="text-align: center; font-size: 20px;">';
        html += `<td> ${index + 1} </td> <td>${item.PRODUCT_NAME}</td> <td>${item.TYPE_UNIT}</td> <td>${item.REAL_PRICE}</td>
                <td>${item.RETURN_COUNT}</td> <td>${item.PRODUCT_FEE}</td> <td>${item.RETURN_REASON}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += `<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 20px;"><div>退货人：</div><div style="margin-left: 200px;font-size: 20px;">主管：</div><div style="margin-left: 200px;font-size: 20px;">制单人：${this.name}</div></div>`;
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
    rowspan() {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.tableData[index].SALES_RETURN_DETAIL_ID === this.tableData[index - 1].SALES_RETURN_DETAIL_ID) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if ([0, 1, 2, 3, 4, 5, 6, 7].includes(columnIndex)) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    getMax(row) {
      const max1 = row.RETURN_RETURN_COUNT - this.tableData.filter((item) => item.SALES_RETURN_DETAIL_ID == row.SALES_RETURN_DETAIL_ID).reduce((total, item) => total += Number(item.RETURN_COUNT), 0);
      const max2 = row.DELIVER_COUNT - row.RETURN_COUNT;
      return Number(Math.min(max1, max2)).toFixed(2);
    },
    getCount(row) {
      if (!/(^[1-9]\d*(.\d+)*$)|(^0.\d+$)/.test(row.COUNT)) {
        this.$message.show({ text: '请输入正确的退库数量', type: 'warning' });
        return false;
      }
      if (!this.$util.JudgmentUnit(row.TYPE_UNIT)) {
        if (Number(row.COUNT) % 1) {
          this.$message.show({ text: '请输入正整数的退库数量', type: 'warning' });
          return false;
        }
      }
      if (Number(row.COUNT) > this.getMax(row)) {
        this.$message.show({ text: '退库数量不能超过最大退库数量', type: 'warning' });
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

ul {
  list-style: none;
  min-height: 5px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/SupplierCusSalesReturnProductDetail.vue